// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bewear: PokeData = {
  "id": 760,
  "name": "bewear",
  "height": 21,
  "weight": 1350,
  "base_experience": 175,
  "types": [
    PokeType.NORMAL,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "bind",
    "tackle",
    "take-down",
    "thrash",
    "double-edge",
    "leer",
    "strength",
    "bide",
    "flail",
    "endure",
    "pain-split",
    "superpower",
    "hammer-arm",
    "payback",
    "baby-doll-eyes",
    "brutal-swing"
  ],
  "moves": [
    "tackle",
    "leer",
    "superpower",
    "close-combat",
    "purification",
    "refresh",
    "scratch",
    "scary-face",
    "meteor-assault",
    "body-slam",
    "supersonic",
    "quick-attack",
    "double-kick"
  ],
  "evolution_chain": {
    "id": 391,
    "item": null,
    "species": [
      {
        "name": "stufful",
        "order": 759,
        "types": [
          PokeType.NORMAL,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "bewear",
        "order": 760,
        "types": [
          PokeType.NORMAL,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 759,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 27,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 136,
    "speed": 86,
    "ability_power": 179
  },
  "stat_changes": [],
  "catch_rate": 70,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
